<div class="financial-report">
  <div style="    padding: 20px;">
    <h4> ANNOUNCEMENTS
    </h4>
  </div>

  <div class="select-year">
    <select class="custom-dropdown custom-dropdown-lg mb-3">
      <option selected>2018</option>
      <option value="1">2018</option>
      <option value="2">2017</option>
      <option value="3">2016</option>
    </select>
  </div>

  <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
    <li [ngbNavItem]="1">
      <a ngbNavLink>JAN-JUN</a>
      <ng-template ngbTabContent>
        06/03/2018 -
        <a class="financial-link"> Investor Presentation</a>
        <br> 05/03/2018 -
        <a class="financial-link"> Dividend Update and Guidance for FY18</a>
        <br> 02/03/2018 -
        <a class="financial-link"> Issue of Shares to Eligible Employees</a>
        <br> 28/02/2018 -
        <a class="financial-link"> 2017 Annual Report</a>
        <br> 28/02/2018 -
        <a class="financial-link"> Appendix 4G and Corporate Governance Statement</a>
        <br> 28/02/2018 -
        <a class="financial-link"> Appendix 4E Preliminary Final Report</a>
        <br>
      </ng-template>
    </li>
    <li [ngbNavItem]="1">
      <a ngbNavLink>JAN-DEC</a>
      <ng-template ngbTabContent>
        06/03/2018 -
        <a class="financial-link"> Investor Presentation</a>
        <br> 05/03/2018 -
        <a class="financial-link"> Dividend Update and Guidance for FY18</a>
        <br> 02/03/2018 -
        <a class="financial-link"> Issue of Shares to Eligible Employees</a>
        <br> 28/02/2018 -
        <a class="financial-link"> 2017 Annual Report</a>
        <br> 28/02/2018 -
        <a class="financial-link"> Appendix 4G and Corporate Governance Statement</a>
        <br> 28/02/2018 -
        <a class="financial-link"> Appendix 4E Preliminary Final Report</a>
        <br> 06/03/2018 -
        <a class="financial-link"> Investor Presentation</a>
        <br> 05/03/2018 -
        <a class="financial-link"> Dividend Update and Guidance for FY18</a>
        <br> 02/03/2018 -
        <a class="financial-link"> Issue of Shares to Eligible Employees</a>
        <br> 28/02/2018 -
        <a class="financial-link"> 2017 Annual Report</a>
        <br> 28/02/2018 -
        <a class="financial-link"> Appendix 4G and Corporate Governance Statement</a>
        <br> 28/02/2018 -
        <a class="financial-link"> Appendix 4E Preliminary Final Report</a>
        <br>
      </ng-template>
    </li>

  </ul>

</div>
